
import { authHeader } from "../../../helpers/authHeader";
import { handleResponse } from "../../../helpers/handleresponse";

export const systemLabelService = {
    get,
    getGroup,
    getAllGroups,
    update,
    updateRange,
    create,
};

async function get(name, languageCode, groupName) {
    const requestOptions = {
        method: "GET",
        headers: authHeader({ "Content-Type": "application/json" }),
    };

    return fetch(`./api/systemLabel/?languageCode=${languageCode}&groupName=${groupName}&name=${name}`, requestOptions)
        .then(handleResponse)
        .then(label => {
            return label;
        });
}
async function create(name, languageCode, groupName) {
    const requestOptions = {
        method: "POST",
        headers: authHeader({ "Content-Type": "application/json" }),
        body:JSON.stringify({labelName:name, languageCode, groupName})
    };

    return fetch(`./api/systemLabel/`, requestOptions)
        .then(handleResponse)
        .then(labelGroup => {
            return labelGroup;
        });
}
async function update(id, value,hint, languageCode, groupName) {
    const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({value, groupName,hint, id, languageCode} )
    };

    return fetch(`./api/systemLabel/`, requestOptions)
        .then(handleResponse);
}
async function updateRange(labelArray) {
    const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(labelArray)
    };

    return fetch(`./api/systemLabel/range/`, requestOptions)
        .then(handleResponse);
}

async function getGroup(languageCode, groupName) {
    const requestOptions = {
        method: "GET",
        headers: authHeader({ "Content-Type": "application/json" }),
    };

    return fetch(`./api/systemLabel/group/?languageCode=${languageCode}&groupName=${groupName}`, requestOptions)
        .then(handleResponse)
        .then(group => {
            return group;
        });
}

async function getAllGroups() {
    const requestOptions = {
        method: "GET",
        headers: authHeader({ "Content-Type": "application/json" }),
    };

    return fetch(`./api/systemLabel/all/`, requestOptions)
        .then(handleResponse)
        .then(groups => {
            return groups;
        });
}

